import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7 36Q5.8 36 4.9 35.1Q4 34.2 4 33V15Q4 13.85 4.9 12.925Q5.8 12 7 12H41Q42.2 12 43.1 12.925Q44 13.85 44 15V33Q44 34.2 43.1 35.1Q42.2 36 41 36ZM7 33H41Q41 33 41 33Q41 33 41 33V15Q41 15 41 15Q41 15 41 15H34.5V24H31.5V15H25.5V24H22.5V15H16.5V24H13.5V15H7Q7 15 7 15Q7 15 7 15V33Q7 33 7 33Q7 33 7 33ZM13.5 24H16.5ZM22.5 24H25.5ZM31.5 24H34.5ZM24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 48 48",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})